<template>
<v-container fluid>
<v-layout wrap>
    <v-flex xs12 style="max-width:100%">
        <v-card class="elevation-1 ma-2">
            <v-toolbar flat dark color="green" >
                <v-toolbar-title><v-icon>mdi-file-excel</v-icon>Export par tache</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon>mdi-download</v-icon>
            </v-toolbar>
            <v-container fluid grid-list-xl >
            <v-layout align-center wrap >
                <v-flex xs6 class="pl-2 pr-2 pa-0"></v-flex>
                <v-flex xs6 class="pl-2 pr-2 pa-0 text-right" >
                    <v-btn class="mt-2 mb-2" outlined color="indigo" @click="addDates">
                        <v-icon>mdi-calendar-plus</v-icon>Ajouter des dates
                    </v-btn>
                </v-flex>
                <v-flex xs12 class="pl-2 pr-2 pa-0">
                    <AutocompleteMulti v-if="false"
                        :title="'Type de tache'" :ressource="'tasktypes'"
                        :listObject.sync="reports.tasks.tsk_tty_id" :listParent.sync="filterSource.tsk_tty_id" 
                        :fields="{ 
                            index: 'tty_id', text:'tty_name', autofocus: true, outlined: true,
                            search:'tty_name', multiSelect:true, prefetch: false, params:'' 
                    }"></AutocompleteMulti>
                </v-flex>
                <v-flex xs6 class="pl-2 pr-2 pa-0">
                    <AutocompleteMulti v-if="false"
                        :title="'Etats'"
                        :listObject.sync="reports.tasks.tsk_sta_id" :listParent.sync="filterSource.tsk_sta_id" 
                        :fields="{ 
                            index: 'sta_id', text:'sta_label', autofocus: true, outlined: true,
                            search:'sta_label', multiSelect:true, prefetch: false, params:'' 
                    }"></AutocompleteMulti>
                </v-flex>
                <v-flex xs6 class="pl-2 pr-2 pa-0">
                    <AutocompleteMulti v-show="false"
                        :title="'Interventions'"
                        :listObject.sync="reports.tasks.tsk_typ_id" :listParent.sync="filterSource.tsk_typ_id" 
                        :fields="{ 
                            index: 'typ_id', text:'typ_name', autofocus: true, outlined: true,
                            search:'typ_name', multiSelect:true, prefetch: false, params:'' 
                    }"></AutocompleteMulti>
                </v-flex>
                <template v-for="(item, index) in datesRange" >
                    <v-flex xs5 class="pl-2 pr-2" :key="'min' + index">
                        <DatePicker label="Executé le" :objectForm="item" fieldName='min_tsk_date_plan'></DatePicker>
                    </v-flex>
                    <v-flex xs5 class="pl-2 pr-2" :key="'max' + index">
                        <DatePicker label="Jusqu'au" :objectForm="item" fieldName='max_tsk_date_plan'></DatePicker>
                    </v-flex>
                    <v-flex xs2 class="pl-2 pr-2 text-right" :key="'del' + index">
                        <v-btn v-if="(!item['min_tsk_date_plan'] || !item['max_tsk_date_plan'])" 
                            title="Un ou plusieurs champs non renseigné(s)"
                            class="ma-2" outlined fab color="orange">
                            <v-icon>mdi-alert-outline</v-icon>
                        </v-btn>
                        <v-btn v-if="index" class="ma-2" outlined fab color="red" @click="removeDate(index)">
                            <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                    </v-flex>
                </template>

            </v-layout>
            </v-container>
            <v-divider class="mt-5"></v-divider>
            <v-card-actions>
                <!-- <v-checkbox v-model="checkState.withConvention" label="Uniquement avec convention" class="mt-0"></v-checkbox> -->
                <v-spacer></v-spacer>
                <v-btn rounded color="success" :disabled="loading.getItem"
                    @click="downloadReport('tasks', 'per_page=false&extended=withtasktype,withsubarea,withtasktypeinter,withstate' + rangeToUrl(datesRange), 'get')">
                    <v-icon left dark>mdi-content-save</v-icon>
                    <span class="hidden-sm-and-down">Telecharger</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-flex>
</v-layout>
</v-container>
</template>

<script>
import { cacheGetters }  from "@/stores/cache.module"
import { tskObj }        from '@/mixins/tsk_obj.js'
import AutocompleteMulti from '@/components/ui/AutocompleteMulti.vue'
import DatePicker        from '@/components/ui/DatePicker'

export default {
    name: 'site-report',
    props: [], 
    mixins: [ tskObj ],
    components: {
        AutocompleteMulti, DatePicker
    },
    data: function () {
        return {
            loading: { getItem: false },
            reports: {
                tasks : { min_tsk_date_plan: null, max_tsk_date_plan: null, tsk_tty_id: [], tsk_typ_id: [] }
            },
            filterSource:{
                tsk_sta_id: [],
                tsk_typ_id: this.getCacheType('TSK'),
                tsk_tty_id: this.getCacheTaskType(),
                typ: [],
            },
            datesRange: [
                { min_tsk_date_plan: null, max_tsk_date_plan: null }
            ]

        }
    },
    beforeMount:function (){
        this.filterSource.tsk_typ_id = cacheGetters.getTypes( 'TSK' )
        this.filterSource.tsk_sta_id = this.getCacheState('TSK')
    },
    methods: {
        getFilterUrl(type){
            let filter = this.reports[type]
            let url    = ''
            for( var prop in filter ){
                if( filter[prop] !== null && filter[prop] !== undefined && filter[prop].length > 0 ){
                    url += (url.length) ? '&' : ''
                    url += prop + '=' + filter[prop]
                }
            }
            return url
        },
        rangeToUrl(table){
            let url = ''
            table.forEach(item => {
                for(const prop in item){
                    url += (item[prop]) ? '&' + prop + '[]=' + item[prop] : ''
                }
            })
            return url
        },
        downloadReport(report, option, method, fileName){
            method               = method || 'get'
            fileName             = fileName || 'rapport'
            this.loading.getItem = true
            let searchCriteria   = this.getFilterUrl(report)
            if( searchCriteria.length > 2 ){
                searchCriteria += '&' + option
            } else {
                searchCriteria  = option
            }
            this.$http.customRequest({ method: method, url: '/report/' + report + '/?' + searchCriteria, responseType: 'blob' } )
            .then( (response) => {
                this.$download(response.data, fileName + ".xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
                this.loading.getItem = false
            }).catch( (error) => {
                this.$root.$toast({ text: 'Erreur lors de l\'extraction !', error: error })
                this.loading.getItem = false
            })
        },
        addDates(){
            this.datesRange.push( { min_tsk_date_plan: null, max_tsk_date_plan: null } )
        },
        removeDate(index){
            this.datesRange.splice(index, 1)
        },
        getCacheState    : cacheGetters.getStates,
        getCacheType     : cacheGetters.getTypes,
        getCacheStates   : cacheGetters.getStates,
        getCacheTaskType : cacheGetters.getTaskType
    }
}
</script>